export default "__VITE_ASSET__RYwKm_f___"